/**
 * 상품 상세페이지(CatalogDetailPage.js) + 하단 예약바(BookingBar.js) + 예약 모달(BookingSheet.js) —
 * 지금까지 t() 없이 한국어가 하드코딩돼 있던 예약 플로우 전체를 국제화. ko/en/vi/ru.
 * (실제 예약이 시작되는 가장 중요한 화면이라 tuple 순서: [ko, en, vi, ru])
 */

const main = {
  pageTitle: ['상품', 'Product', 'Sản phẩm', 'Товар'],
  notFoundTitle: [
    '상품을 찾을 수 없어요',
    'Product not found',
    'Không tìm thấy sản phẩm',
    'Товар не найден',
  ],
  notFoundHint: [
    '게시되지 않았거나 비공개 상품일 수 있어요. 업체라면 대시보드에서 「게시」를 눌러 주세요.',
    'It may not be published or may be private. If you’re the host, tap "Publish" in the dashboard.',
    'Sản phẩm có thể chưa được đăng hoặc ở chế độ riêng tư. Nếu bạn là chủ, hãy nhấn "Đăng" trong bảng điều khiển.',
    'Возможно, товар не опубликован или скрыт. Если вы владелец, нажмите «Опубликовать» в панели управления.',
  ],
  paidConfirmedToast: [
    '{mode} 결제가 완료됐어요. 예약이 접수됐어요.',
    '{mode} payment complete. Your booking has been submitted.',
    'Đã thanh toán {mode}. Yêu cầu đặt chỗ đã được gửi.',
    'Оплата ({mode}) завершена. Бронирование отправлено.',
  ],
  durationHoursFormat: ['{hours}시간', '{hours}h', '{hours} giờ', '{hours} ч'],
  previewBanner: [
    '미게시 미리보기 — 고객에게는 아직 보이지 않아요. 대시보드에서 게시하면 노출됩니다.',
    'Unpublished preview — not visible to customers yet. It will appear once you publish it from the dashboard.',
    'Xem trước chưa đăng — khách hàng chưa thấy được. Sẽ hiển thị sau khi bạn đăng từ bảng điều khiển.',
    'Предпросмотр (не опубликовано) — клиентам пока не видно. Появится после публикации в панели управления.',
  ],
  noPackageAvailable: [
    '예약 가능한 패키지가 없어요. 채팅으로 문의해 주세요.',
    'No bookable package available. Please contact us via chat.',
    'Không có gói nào khả dụng để đặt. Vui lòng liên hệ qua trò chuyện.',
    'Нет доступных пакетов для бронирования. Свяжитесь с нами в чате.',
  ],
  requestSentToast: [
    '예약 요청이 접수됐어요. 업체와 대화 후 확정돼요.',
    'Your booking request has been sent. It will be confirmed after chatting with the host.',
    'Yêu cầu đặt chỗ đã được gửi. Sẽ được xác nhận sau khi trò chuyện với đơn vị cung cấp.',
    'Запрос на бронирование отправлен. Будет подтверждён после общения с поставщиком услуг.',
  ],
  instantBookBadge: ['즉시확정', 'Instant confirm', 'Xác nhận ngay', 'Мгновенное подтверждение'],
  partnerConfirmBadge: ['업체확인', 'Confirm by host', 'Xác nhận bởi đơn vị', 'Подтверждение продавцом'],
  pickupBadge: ['픽업', 'Pickup', 'Đón khách', 'Трансфер'],
  freeCancelBadge: ['무료취소', 'Free cancellation', 'Hủy miễn phí', 'Бесплатная отмена'],
  noRefundBadge: ['취소 불가', 'Non-refundable', 'Không hoàn hủy', 'Без возврата'],
  discountSectionTitle: ['할인 정보', 'Discount', 'Ưu đãi', 'Скидка'],
  priceFromTo: [
    '정가 {list} → 할인가 {base}',
    'List price {list} → Sale price {base}',
    'Giá gốc {list} → Giá giảm {base}',
    'Обычная цена {list} → Цена со скидкой {base}',
  ],
  discountAppliedLabel: [
    '{rate}% 할인 적용',
    '{rate}% discount applied',
    'Áp dụng giảm {rate}%',
    'Применена скидка {rate}%',
  ],
  serviceInfoTitle: ['서비스 정보', 'Service info', 'Thông tin dịch vụ', 'Информация об услуге'],
  durationLabel: [
    '소요 시간: {duration}',
    'Duration: {duration}',
    'Thời lượng: {duration}',
    'Продолжительность: {duration}',
  ],
  comboSectionTitle: ['🎁 콤보 구성', '🎁 Combo package', '🎁 Gói combo', '🎁 Комбо-набор'],
  comboTotalDuration: [
    '총 소요시간: {duration}',
    'Total duration: {duration}',
    'Tổng thời lượng: {duration}',
    'Общая продолжительность: {duration}',
  ],
  descriptionTitle: ['상세 설명', 'Details', 'Mô tả chi tiết', 'Подробное описание'],
  businessInfoTitle: ['업체 정보', 'About the host', 'Thông tin đơn vị cung cấp', 'О поставщике услуг'],
  businessInfoHint: [
    '문의는 하단 고정 버튼에서 바로 채팅으로 연결됩니다.',
    'You can chat directly using the button fixed at the bottom.',
    'Bạn có thể trò chuyện trực tiếp bằng nút cố định ở dưới cùng.',
    'Вы можете написать напрямую, используя кнопку внизу экрана.',
  ],
  businessFallback: ['업체', 'Business', 'Đơn vị', 'Поставщик услуг'],
  labelPreview: [
    '게시 후 예약 가능',
    'Bookable after publishing',
    'Có thể đặt sau khi đăng',
    'Бронирование доступно после публикации',
  ],
  labelConsult: ['상담 신청', 'Request consultation', 'Yêu cầu tư vấn', 'Запросить консультацию'],
  labelBook: ['예약하기', 'Book now', 'Đặt ngay', 'Забронировать'],
  menuFallback: ['메뉴', 'Menu', 'Thực đơn', 'Меню'],
};

const reviews = {
  sectionTitle: ['리뷰', 'Reviews', 'Đánh giá', 'Отзывы'],
  empty: ['아직 리뷰가 없어요', 'No reviews yet', 'Chưa có đánh giá nào', 'Отзывов пока нет'],
  countSuffix: ['리뷰 {count}개', '{count} reviews', '{count} đánh giá', '{count} отзывов'],
  loadMore: ['리뷰 더 보기', 'More reviews', 'Xem thêm đánh giá', 'Больше отзывов'],
  anonymous: ['익명', 'Anonymous', 'Ẩn danh', 'Аноним'],
};

const bookingSheet = {
  title: ['예약하기', 'Book', 'Đặt chỗ', 'Бронирование'],
  dateLabel: ['날짜', 'Date', 'Ngày', 'Дата'],
  dateListAria: ['예약 날짜', 'Booking date', 'Ngày đặt chỗ', 'Дата бронирования'],
  timeLabel: ['시간', 'Time', 'Giờ', 'Время'],
  noTimeSlotHint: [
    '이 날짜는 예약 가능한 시간이 없어요. 다른 날짜를 선택해 주세요.',
    'No available time slots on this date. Please choose another date.',
    'Không có khung giờ trống vào ngày này. Vui lòng chọn ngày khác.',
    'На эту дату нет свободного времени. Пожалуйста, выберите другую дату.',
  ],
  timeDiscountFallback: ['시간대 할인', 'Time-slot discount', 'Giảm giá theo khung giờ', 'Скидка по времени'],
  timeDiscountBadge: [
    '🔥 {label} · {percent}% 할인 적용',
    '🔥 {label} · {percent}% off',
    '🔥 {label} · Giảm {percent}%',
    '🔥 {label} · Скидка {percent}%',
  ],
  adultsLabel: ['성인', 'Adults', 'Người lớn', 'Взрослые'],
  childrenLabel: ['아동', 'Children', 'Trẻ em', 'Дети'],
  totalLabel: ['합계', 'Total', 'Tổng cộng', 'Итого'],
  payMethodLabel: ['결제 방식', 'Payment method', 'Phương thức thanh toán', 'Способ оплаты'],
  depositLabel: ['예약금', 'Deposit', 'Đặt cọc', 'Депозит'],
  fullLabel: ['전액', 'Full amount', 'Toàn bộ', 'Полная сумма'],
  requestWithoutPayBtn: [
    '결제 없이 예약 요청',
    'Request without payment',
    'Yêu cầu đặt chỗ không cần thanh toán',
    'Запрос без оплаты',
  ],
  processingLabel: ['처리 중…', 'Processing…', 'Đang xử lý…', 'Обработка…'],
  requestBtn: ['예약 요청하기', 'Request booking', 'Gửi yêu cầu đặt chỗ', 'Отправить запрос'],
  closeBtn: ['닫기', 'Close', 'Đóng', 'Закрыть'],
  selectTimeToast: [
    '예약 시간을 선택해 주세요.',
    'Please select a time.',
    'Vui lòng chọn giờ.',
    'Пожалуйста, выберите время.',
  ],
  slotsLeft: ['{count}자리 남음', '{count} spots left', 'Còn {count} chỗ', 'Осталось {count} мест'],
  almostFull: ['마감임박', 'Almost full', 'Sắp hết chỗ', 'Мест почти нет'],
  cardInfoLabel: ['카드 정보', 'Card info', 'Thông tin thẻ', 'Данные карты'],
  testCardHint: [
    '테스트: 성공 4242 4242 4242 4242 · 실패 4000 0000 0000 0002',
    'Test: success 4242 4242 4242 4242 · fail 4000 0000 0000 0002',
    'Thử nghiệm: thành công 4242 4242 4242 4242 · thất bại 4000 0000 0000 0002',
    'Тест: успех 4242 4242 4242 4242 · ошибка 4000 0000 0000 0002',
  ],
  payBtn: ['{label} 결제하기', 'Pay {label}', 'Thanh toán {label}', 'Оплатить {label}'],
  payProcessing: ['결제 처리 중…', 'Processing payment…', 'Đang xử lý thanh toán…', 'Обработка платежа…'],
  stripeLoading: [
    'Stripe를 불러오는 중이에요. 잠시 후 다시 시도해 주세요.',
    'Loading payment system. Please try again shortly.',
    'Đang tải hệ thống thanh toán. Vui lòng thử lại sau.',
    'Загрузка платёжной системы. Повторите попытку позже.',
  ],
  bookingFailToast: [
    '예약 접수에 실패했어요.',
    'Failed to submit booking.',
    'Gửi yêu cầu đặt chỗ thất bại.',
    'Не удалось отправить бронирование.',
  ],
  noPaymentServer: [
    '결제 서버가 연결되지 않았어요. 관리자에게 문의해 주세요.',
    'Payment server not connected. Please contact support.',
    'Máy chủ thanh toán chưa được kết nối. Vui lòng liên hệ hỗ trợ.',
    'Платёжный сервер не подключён. Обратитесь в поддержку.',
  ],
  loginRequired: ['로그인이 필요해요.', 'Login required.', 'Cần đăng nhập.', 'Требуется вход в систему.'],
  payPrepFail: [
    '결제 준비에 실패했어요.',
    'Failed to prepare payment.',
    'Chuẩn bị thanh toán thất bại.',
    'Не удалось подготовить платёж.',
  ],
  cardPayFail: [
    '카드 결제에 실패했어요.',
    'Card payment failed.',
    'Thanh toán thẻ thất bại.',
    'Оплата картой не удалась.',
  ],
  payNotCompleted: [
    '결제가 완료되지 않았어요.',
    'Payment was not completed.',
    'Thanh toán chưa hoàn tất.',
    'Платёж не завершён.',
  ],
  payError: [
    '결제 중 오류가 발생했어요.',
    'An error occurred during payment.',
    'Đã xảy ra lỗi khi thanh toán.',
    'Произошла ошибка при оплате.',
  ],
};

const bookingBar = {
  chatInquiry: ['채팅 문의', 'Chat inquiry', 'Hỏi qua trò chuyện', 'Написать в чат'],
  consultRequest: ['상담 신청', 'Request consultation', 'Yêu cầu tư vấn', 'Запросить консультацию'],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, v]) => {
    out[k] = Array.isArray(v) ? v[langIndex] : v;
  });
  return out;
}

function buildLang(langIndex) {
  return {
    catalogDetail: {
      main: pick(main, langIndex),
      reviews: pick(reviews, langIndex),
    },
    bookingSheet: pick(bookingSheet, langIndex),
    bookingBar: pick(bookingBar, langIndex),
  };
}

export const phaseCatalogBookingKo = buildLang(0);
export const phaseCatalogBookingEn = buildLang(1);
export const phaseCatalogBookingVi = buildLang(2);
export const phaseCatalogBookingRu = buildLang(3);
